import React from 'react';

const CookiePolicy = () => {
  return (
    <div style={styles.page}>
      <div style={styles.content}>
        <h1>Cookie &amp; Storage Policy</h1>
        <p style={styles.updated}>Last updated: February 2026</p>

        <h2>Cookies</h2>
        <p>
          This website does <strong>not</strong> set any HTTP cookies. You will not find any cookies
          from this site in your browser's cookie storage.
        </p>

        <h2>Local storage</h2>
        <p>
          We use your browser's <strong>local storage</strong> (not cookies) to make the site work
          correctly. Local storage is similar to cookies but is never sent to our servers with each
          request — it stays in your browser. The table below lists everything we store and why.
        </p>

        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Key</th>
                <th style={styles.th}>Contents</th>
                <th style={styles.th}>Purpose</th>
                <th style={styles.th}>Legal basis</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={styles.td}><code>persist:preferences</code></td>
                <td style={styles.td}>Your chosen language</td>
                <td style={styles.td}>Remembers your language preference across page loads</td>
                <td style={styles.td}>Strictly necessary</td>
              </tr>
              <tr style={styles.trAlt}>
                <td style={styles.td}><code>persist:domainData</code></td>
                <td style={styles.td}>Site configuration and page list</td>
                <td style={styles.td}>Caches site structure fetched from our API to speed up navigation</td>
                <td style={styles.td}>Strictly necessary</td>
              </tr>
              <tr>
                <td style={styles.td}><code>persist:dynamicData</code></td>
                <td style={styles.td}>Page content blocks</td>
                <td style={styles.td}>Caches dynamic content from our API to avoid repeated network requests</td>
                <td style={styles.td}>Strictly necessary</td>
              </tr>
              <tr style={styles.trAlt}>
                <td style={styles.td}><code>persist:store</code></td>
                <td style={styles.td}>Product catalogue data</td>
                <td style={styles.td}>Caches store/product information for the shopping section</td>
                <td style={styles.td}>Strictly necessary</td>
              </tr>
              <tr>
                <td style={styles.td}><code>persist:rssData</code></td>
                <td style={styles.td}>RSS feed content and timestamps</td>
                <td style={styles.td}>Caches news/blog feed so it loads instantly on repeat visits</td>
                <td style={styles.td}>Strictly necessary</td>
              </tr>
              <tr style={styles.trAlt}>
                <td style={styles.td}><code>gdpr:consent</code></td>
                <td style={styles.td}>Timestamp and version of consent acknowledgement</td>
                <td style={styles.td}>Records that you have seen and dismissed this notice so it does not reappear</td>
                <td style={styles.td}>Strictly necessary</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2>No advertising or tracking</h2>
        <p>
          We do not use Google Analytics, Meta Pixel, Google Tag Manager, Hotjar, or any other
          analytics or advertising platform. None of the data listed above is shared with advertisers
          or used to build a profile of you.
        </p>

        <h2>Fonts</h2>
        <p>
          The Montserrat typeface used on this site is served from our own servers. No request is
          made to Google Fonts or any third-party font provider, so your IP address is not shared
          with Google in connection with loading this site's typography.
        </p>

        <h2>How to clear local storage</h2>
        <p>
          You can clear local storage at any time through your browser's developer tools or settings:
        </p>
        <ul>
          <li><strong>Chrome / Edge:</strong> DevTools → Application → Local Storage → right-click → Clear</li>
          <li><strong>Firefox:</strong> DevTools → Storage → Local Storage → right-click → Delete All</li>
          <li><strong>Safari:</strong> Develop → Show Web Inspector → Storage → Local Storage → Clear</li>
        </ul>
        <p>
          Clearing local storage will reset your language preference and remove cached content; the
          site will re-fetch everything on your next visit.
        </p>

        <h2>More information</h2>
        <p>
          See our full <a href="/privacy-policy">Privacy Policy</a> or visit{' '}
          <a href="https://www.any-web.uk/legal_privacy.aspx">any-web.uk/legal_privacy</a> for
          further details.
        </p>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: '100vh',
    padding: '40px 16px',
    background: '#fff',
  },
  content: {
    maxWidth: '900px',
    margin: '0 auto',
    fontFamily: 'Montserrat, sans-serif',
    color: '#1a1b1f',
    lineHeight: '1.7',
  },
  updated: {
    color: '#666',
    fontSize: '14px',
    marginBottom: '32px',
  },
  tableWrapper: {
    overflowX: 'auto',
    marginBottom: '24px',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px',
  },
  th: {
    background: '#1a1b1f',
    color: '#fff',
    padding: '10px 14px',
    textAlign: 'left',
    fontWeight: 600,
  },
  td: {
    padding: '10px 14px',
    borderBottom: '1px solid #e0e0e0',
    verticalAlign: 'top',
  },
  trAlt: {
    background: '#f9f9f9',
  },
};

export default CookiePolicy;
